import SpecRow from './SpecRow';

// TODO: Add imperial/metric toggle support

/**
 * SpecTable — Specifications table for the PDP.
 *
 * Supports two modes:
 *   1. Standard (flat) — renders fieldConfig directly as rows.
 *   2. Grouped (DTH hammers) — renders specGroups with sub-headings.
 *
 * @param {object}  product      — product data object
 * @param {Array}   fieldConfig  — from getPDPFieldConfig: [{key, label, source, unit?, isHarveyBall?, imperialField?, imperialUnit?}]
 * @param {object}  [specGroups] — optional grouped layout: { groupKey: { label, fields: [...] } }
 */
export default function SpecTable({ product, fieldConfig = [], specGroups }) {
  if (!product) return null;

  // ── Grouped mode (DTH hammers) ──────────────────────────────
  if (specGroups) {
    return (
      <div className="divide-y divide-n2">
        {Object.entries(specGroups).map(([groupKey, group]) => {
          // Resolve each field in the group against fieldConfig
          const groupFields = (group.fields || [])
            .map((fieldKey) => {
              const cfg = fieldConfig.find((f) => f.key === fieldKey);
              if (!cfg) return null;
              const value = product[cfg.key];
              if (value === null || value === undefined || value === '') return null;
              return { ...cfg, value };
            })
            .filter(Boolean);

          if (groupFields.length === 0) return null;

          return (
            <div key={groupKey}>
              <h3 className="text-base font-normal text-carbon-black font-sandvik-headline px-4 pt-4 pb-2">
                {group.label}
              </h3>
              {groupFields.map((field, idx) => (
                <SpecRow
                  key={field.key}
                  label={field.label}
                  value={field.value}
                  unit={field.unit}
                  isHarveyBall={!!field.isHarveyBall}
                  renderAs={field.renderAs}
                  alternate={idx % 2 === 0}
                />
              ))}
            </div>
          );
        })}
      </div>
    );
  }

  // ── Standard (flat) mode ────────────────────────────────────
  // Pre-filter to only fields with values so alternating rows look clean
  const validFields = fieldConfig
    .map((field) => {
      const value = product[field.key];
      if (value === null || value === undefined || value === '') return null;
      return { ...field, value };
    })
    .filter(Boolean);

  if (validFields.length === 0) return null;

  return (
    <div className="divide-y divide-n2">
      {validFields.map((field, idx) => (
        <SpecRow
          key={field.key}
          label={field.label}
          value={field.value}
          unit={field.unit}
          isHarveyBall={!!field.isHarveyBall}
          renderAs={field.renderAs}
          alternate={idx % 2 === 0}
        />
      ))}
    </div>
  );
}
